import { withTw } from "./with-tw";

export const Select = withTw("select", "border select-bordered select select-xs");

export const H1 = withTw("h1", "");
export const H2 = withTw("h2", "");
export const H3 = withTw("h3", "");
export const H4 = withTw("h3", "");
